import React from "react"
import { headingTriangle } from "../../../../static/svgs/agenda"
import { AgendaProps } from "../../types/agendaTypes"
import HeadingText from "./texts/HeadingText"
import "./styles.css"

export default function DesktopAgenda({
  activeId,
  isShown = true,
  headings,
  onScroll,
  title,
}: AgendaProps) {
  return (
    <nav
      className={`scrollbar max-h-[420px] 2xl:max-h-[640px] overflow-y-auto md:max-w-[200px] lg:max-w-[224px] xl:max-w-[250px] 2xl:max-w-[312px] fixed top-1/2 -translate-y-1/2 md:right-1 lg:right-2 xl:right-6 2xl:right-1 md:w-64 lg:w-96 py-6 px-8 md:px-4 transition-opacity ${
        isShown ? "opacity-100" : "opacity-0"
      }`}
      style={{
        background: "rgba(255, 255, 255, 0.1)",
        boxShadow:
          "-10px -10px 30px rgba(0, 0, 0, 0.25), 10px 10px 30px rgba(0, 0, 0, 0.25)",
        backdropFilter: "blur(12.5px)",
        WebkitBackdropFilter: "blur(12.5px)",
        borderRadius: "20px",
      }}
    >
      <span className="font-jost-medium font-medium md:text-base lg:text-lg xl:text-xl 2xl:text-2xl text-white">
        {title}
      </span>
      <ul>
        {headings.map(heading => (
          <li
            key={heading.id}
            className="flex align-middle md:py-1"
            onClick={_e => onScroll(heading.id)}
            style={{
              marginLeft: `${heading.level - 1}em`,
            }}
          >
            <img
              alt=""
              className={`md:h-3 lg:h-4 xl:h-5 md:pt-1 lg:pt-1 ${
                activeId === heading.id ? "visible" : "invisible"
              }`}
              src={headingTriangle}
            />
            <HeadingText>{heading.text}</HeadingText>
          </li>
        ))}
      </ul>
    </nav>
  )
}
